// 商品分類別売上実績表 API クライアント

import { FileClient } from "../RestClient";

export type B110020Request = Partial<{
  taishoYm: string;
  eigyoCd: string;
  shokaKbn: string;
  tokuibunCd1: string;
  tokuibunCd2: string;
  shobunCd1From: string;
  shobunCd1To: string;
}>;

export const B110020GetExcel = async (props: B110020Request) => {
  return FileClient.get("b110020/get/excel", { params: props });
};
